// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scope-select[data-v-8c2ab32a]{min-width:33%;width:unset}.expiry[data-v-8c2ab32a]{display:flex}.expiry>*[data-v-8c2ab32a]{flex:0 0 200px;margin-right:10px}.buttons[data-v-8c2ab32a]{display:grid;grid-template-areas:\"left right\";grid-template-columns:\"min-content auto\"}.buttons .right[data-v-8c2ab32a]{grid-area:right;text-align:right}.buttons .right .btn[data-v-8c2ab32a],.buttons .right button[data-v-8c2ab32a]{margin:0 0 0 1.75%}", ""]);
// Exports
module.exports = exports;
